/**
 * Abholgebiet Gassi-Service: Stadtteile, in denen wir REGELMÄSSIG abholen. Eine Quelle für
 * /gassi-service (Abschnitt „Abholgebiet“) und /hundesitter-muenchen (Stadtteil-Chips, FAQ),
 * sichtbar wie im Roh-HTML (src/lib/rohRouten.ts).
 *
 * DATENBASIS (LOOP-2, Abfrage 14.10.2026, nur lesend, aggregiert, keine Personendaten):
 * charliescrew `adventure_bookings`, Gassi-Ausflüge der letzten 90 Tage (Status confirmed/completed,
 * ohne Schnuppertag und Hundetagesstätte), Abhol-PLZ zu Stadtteilen gebündelt. Aufgenommen wurde,
 * wer in 90 Tagen an mindestens 20 Tagen und mit mindestens fünf verschiedenen Hunden abgeholt
 * wurde. Die Zahlen stehen NICHT auf der Seite (Copy-Regel: nichts Quantifizierbares über
 * Größe/Reichweite), nur im PR-Body.
 *
 * Bewusst NICHT dabei: Umland (Gröbenzell, Karlsfeld, Oberhaching u. a., einzelne Hunde und seit
 * 25.09.2026 durch das Umland-Gate begrenzt), Stadtteile unter der Schwelle (Giesing, Laim, Lehel,
 * Ludwigsvorstadt, Milbertshofen, Feldmoching). „Stadtgebiet München“ bleibt die Aussage, die
 * Liste ist ein Auszug („unter anderem“), keine Zusage für jede Adresse.
 *
 * REGELN: rein (kein React, keine Aliase, keine Browser-APIs). Die Slugs müssen zu
 * GASSI_STADTTEILE in gassiStadtteile.ts passen. Diese Datei importiert gassiStadtteile.ts bewusst
 * NICHT, sonst landen alle Stadtteil-Texte im Chunk der Gassi-Landingpage.
 *
 * CHUNK: Die Datei steht in vite.config.ts in der app-shared-Liste. Sonst baut Rollup für die zwei
 * Seiten, die sie nutzen, einen eigenen Mini-Chunk (gemessen 14.10.2026: /gassi-service 18 → 19
 * JS-Dateien). In app-shared kostet sie nur wenige hundert Byte.
 */

export interface AbholStadtteil {
  name: string;
  /** Eigene Stadtteilseite /gassi/<slug>, falls vorhanden. */
  slug?: string;
}

export const GASSI_ABHOLGEBIET: AbholStadtteil[] = [
  { name: "Schwabing", slug: "schwabing" },
  { name: "Maxvorstadt", slug: "maxvorstadt" },
  { name: "Neuhausen-Nymphenburg", slug: "neuhausen-nymphenburg" },
  { name: "Bogenhausen", slug: "bogenhausen" },
  { name: "Au-Haidhausen", slug: "au-haidhausen" },
  { name: "Sendling", slug: "sendling" },
  { name: "Isarvorstadt" },
  { name: "Altstadt" },
  { name: "Westend" },
  { name: "Hadern" },
  { name: "Pasing" },
  { name: "Moosach" },
  { name: "Berg am Laim" },
  { name: "Solln" },
];

/** „Schwabing, Maxvorstadt, … und Solln“ für Fließtext und FAQ-Antworten. */
export function abholgebietText(): string {
  const namen = GASSI_ABHOLGEBIET.map((s) => s.name);
  return `${namen.slice(0, -1).join(", ")} und ${namen[namen.length - 1]}`;
}
